import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import { Card, Popover, Table, Tag } from "antd";
import { useDataStore } from "../../store";
import { formattedAmount } from "../../utils";
import dayjs from "dayjs";
//1. 高危
//支付宝删除账单

//@数据就绪
//非近一年微信账单，请引导客户选中后重新投递
//非近一年支付宝账单，请引导客户选中后重新投递
//账单时间过短，请引导客户选中后重新投递

//2. 风险
//支付活跃度过低

//3. 优质
//用车记录
//理财收益
//交税纳税
//个体经营户
export function RiskAnalysis (){

    const riskItems = useDataStore(state => state.riskItems);
    const getOrderDetail = useDataStore(state => state.getOrderDetail);
    const inquireTime =  useDataStore(state => state.inquiryTime);
    const [ riskData, setRiskData ] = useState([]);

    useEffect(() => {
        let _riskData = [];

        if( inquireTime && dayjs(inquireTime).isBefore(dayjs().subtract(7, 'days')) ) {
            _riskData.push({
                key: 'inquiryTime',
                level: 'high',
                type: '时效超限',
                description: `检测到账单查询时间超过7天，请引导客户重新投递。`
            });
        }

        if( riskItems.usuryPlatform?.size > 0 ){
            _riskData.push({       
                key: 'usury',
                level: 'high',
                type: '高息借贷',
                description: `检测到与 ${riskItems.usuryPlatform?.size} 个高息借贷机构产生交易，请注意风险。`
            });
        }
        if( riskItems.leasePlatform?.size > 0 ){
            _riskData.push({
                key: 'lease',
                level: 'high',
                type: '租赁平台',
                description: `检测到与 ${riskItems.leasePlatform?.size} 个租赁机构产生交易，请注意风险。`
            });
        }

        if( riskItems.largeAmountOrdersCount?.count > 1 ){
            _riskData.push({
                key: 'largeAmount',
                level: 'medium',
                type: '大额交易',
                description: `检测到 ${riskItems.largeAmountOrdersCount?.count} 笔大额交易，请注意资金流动。`,
                orders: riskItems.largeAmountOrdersCount?.orders
            });
        }

        if( riskItems.lastMonthRepayment?.count > 0 && riskItems.lastMonthRepayment?.amount > 10000 ){
            _riskData.push({
                key: 'lastMonthRepayment',
                level: 'medium',
                type: '还款压力',
                description: `检测到 ${riskItems.lastMonthRepayment?.count} 笔近一个月的还款交易共 ${formattedAmount(riskItems.lastMonthRepayment?.amount)} 元，请注意还款压力评估。`,
                orders: riskItems.lastMonthRepayment?.orders
            });
        }

        if( riskItems.vehicleConsumption?.count > 0 ){
            _riskData.push({
                key: 'privateCar',
                level: 'low',
                type: '疑似车产',
                description: `检测到与 ${riskItems.vehicleConsumption?.count} 个疑似车产相关的交易，可确认资产信息`,
                orders: riskItems.vehicleConsumption?.orders
            });
        }

        if( riskItems.familyConsumption?.count > 0 ){
            _riskData.push({
                key: 'familyConsumption',
                level: 'low',
                type: '家庭支出',
                description: `检测到与 ${riskItems.familyConsumption?.count} 笔家庭支出相关的交易，可确认资产信息`,
                orders: riskItems.familyConsumption?.orders
            });
        }

        setRiskData( _riskData );

    }, [ riskItems, inquireTime ]);

    return <Card title="风险分析" className="risk-analysis">
        <Table size="middle" columns={[{
            title: '风险等级', dataIndex: 'level', key: 'level', render: (text) => {
                const colorMap = {
                    high: 'red',
                    medium: 'orange',
                    low: 'green'
                };
                const textMap = {
                    high: '高风险',
                    medium: '中风险',
                    low: '优质项'
                };
                return <Tag color={colorMap[text]}>{textMap[text]}</Tag>;
            }},
            { title: '风险类型', dataIndex: 'type', key: 'type' },
            { title: '风险描述', dataIndex: 'description', key: 'description' },
            { title: '操作', dataIndex: 'action', key: 'action', render: (__, record) => {
                if( record.orders && record.orders.length > 0 ){
                    let ordersDetail = _.sortBy(record.orders.map( order => {
                        //根据订单ID获取订单详情，并根据时间倒序
                        return getOrderDetail(order);
                    }), 'TIME_YMD').reverse();
                    return <Popover trigger="click" content={
                        <Table
                            pagination={{ pageSize: 5, showSizeChanger: false }}
                            dataSource={ordersDetail}
                            columns={[
                                { title: '时间', dataIndex: 'TIME_YMD', key: 'TIME_YMD' },
                                { title: '交易说明', dataIndex: 'TYPE', key: 'TYPE' },
                                { title: '收/支', dataIndex: 'IE', key: '_IE' },
                                { title: '交易方式', dataIndex: 'TRADING', key: 'TRADING' },
                                { title: '金额', dataIndex: 'AMOUNT', key: 'AMOUNT', render: (text) => formattedAmount(text) },
                                { title: '交易对方', dataIndex: 'PARTY', key: 'PARTY' },
                            ]}
                        />
                    } title={`交易流水`}>
                        <a>查看明细</a>
                    </Popover>;
                }
            }}
        ]} dataSource={riskData} pagination={false}>
        </Table>
    </Card>
}